// extracted by mini-css-extract-plugin
export default {"kpi_title":"kpi_kpi_title__WmECI","kpi_value":"kpi_kpi_value__vb+Dk","kpi_wrapper":"kpi_kpi_wrapper__k0XUl","kpi_wrapper_tall":"kpi_kpi_wrapper_tall__XdQGi"};